import React from 'react';
import { fmt } from '../../data/metrics';

export function GuestFlowBar({
  served,
  incoming,
  stillBooked,
  bookedByClose,
}: {
  served: number;
  incoming: number;
  stillBooked: number;
  bookedByClose: number;
}) {
  const denom = Math.max(bookedByClose, 1);
  return (
    <div className="rib-flow">
      <div
        className="segbar"
        role="img"
        aria-label="served, booked and projected guests"
      >
        <span
          className="seg served"
          style={{ width: `${(served / denom) * 100}%` }}
        />
        {incoming > 0 && (
          <span
            className="seg booked"
            style={{ width: `${(incoming / denom) * 100}%` }}
          />
        )}
        {stillBooked > 0 && (
          <span
            className="seg ghost"
            style={{ width: `${(stillBooked / denom) * 100}%` }}
          />
        )}
      </div>
      <div className="kcl-legend">
        <span className="kcl-leg">
          <span className="lsw served" />
          {fmt.num(served)} served
        </span>
        <span className="kcl-leg">
          <span className="lsw booked" />+{incoming} booked · 2h
        </span>
        <span className="kcl-leg">
          <span className="lsw ghost" />
          {fmt.num(stillBooked)} still booked
        </span>
      </div>
    </div>
  );
}
